import { useEffect, useState } from "react";

// A transit brief that could not be saved for offline use because the device
// is out of space (Jill 2026-09-24). Saving used to fail in silence, and the
// pilot found out at sea with no brief. saveBriefCache (voyagePlanBrief.js)
// raises the events; a later successful save of the same trip clears it.
export default function BriefSaveWarning() {
  const [failed, setFailed] = useState(null); // { tripId, label }
  useEffect(() => {
    const onFail = (e) => setFailed(e.detail || {});
    const onSaved = (e) => setFailed((cur) => (cur && cur.tripId === e.detail?.tripId ? null : cur));
    window.addEventListener("seapa:brief-save-failed", onFail);
    window.addEventListener("seapa:brief-saved", onSaved);
    return () => {
      window.removeEventListener("seapa:brief-save-failed", onFail);
      window.removeEventListener("seapa:brief-saved", onSaved);
    };
  }, []);
  if (!failed) return null;
  return (
    <div
      role="alert"
      style={{
        background: "var(--danger-bg, var(--warn-bg))",
        color: "var(--danger-fg, var(--warn-fg))",
        borderBottom: "1px solid var(--danger-border, var(--warn-border))",
        padding: "8px 16px",
        fontSize: "0.85rem",
        fontWeight: 600,
        textAlign: "center",
      }}
    >
      Couldn't save the {failed.label ? `${failed.label} ` : ""}transit brief for offline use. This device is out of
      storage space. Free up space, then open the voyage plan again while you have internet.
      <button
        type="button"
        onClick={() => setFailed(null)}
        style={{
          marginLeft: 10, padding: "2px 10px", fontWeight: 700, fontSize: "0.8rem",
          background: "transparent", color: "inherit", border: "1px solid currentColor",
          borderRadius: 4, cursor: "pointer",
        }}
      >
        OK
      </button>
    </div>
  );
}
